import _classCallCheck from "/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf.js";
import _inherits from "/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/inherits.js";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/dropdown/dropdownpanelview
 */
import View from "../view";
/**
 * The dropdown panel view class.
 *
 * See {@link module:ui/dropdown/dropdownview~DropdownView} to learn about the common usage.
 *
 * @extends module:ui/view~View
 */

var DropdownPanelView =
/*#__PURE__*/
function (_View) {
  _inherits(DropdownPanelView, _View);

  /**
   * @inheritDoc
   */
  function DropdownPanelView(locale) {
    var _this;

    _classCallCheck(this, DropdownPanelView);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DropdownPanelView).call(this, locale));
    var bind = _this.bindTemplate;
    /**
     * Controls whether the panel is visible.
     *
     * @observable
     * @member {Boolean} #isVisible
     */

    _this.set('isVisible', false);
    /**
     * The position of the panel, relative to the parent.
     *
     * This property is reflected in the CSS class set to {@link #element} that controls
     * the position of the panel.
     *
     * @observable
     * @default 'se'
     * @member {'se'|'sw'|'ne'|'nw'} #position
     */


    _this.set('position', 'se');
    /**
     * Collection of the child views in this panel.
     *
     * A common child type is the {@link module:ui/list/listview~ListView} and {@link module:ui/toolbar/toolbarview~ToolbarView}.
     * See {@link module:ui/dropdown/utils~addListToDropdown} and
     * {@link module:ui/dropdown/utils~addToolbarToDropdown} to learn more about child views of dropdowns.
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection}
     */


    _this.children = _this.createCollection();

    _this.setTemplate({
      tag: 'div',
      attributes: {
        class: ['ck', 'ck-reset', 'ck-dropdown__panel', bind.to('position', function (value) {
          return "ck-dropdown__panel_".concat(value);
        }), bind.if('isVisible', 'ck-dropdown__panel-visible')]
      },
      children: _this.children,
      on: {
        // Drag and drop in the panel should not break the selection in the editor.
        // https://github.com/ckeditor/ckeditor5-ui/issues/228
        selectstart: bind.to(function (evt) {
          return evt.preventDefault();
        })
      }
    });

    return _this;
  }
  /**
   * Focuses the view element or first item in view collection on opening dropdown's panel.
   *
   * See also {@link module:ui/dropdown/dropdownpanelfocusable~DropdownPanelFocusable}.
   */


  _createClass(DropdownPanelView, [{
    key: "focus",
    value: function focus() {
      if (this.children.length) {
        this.children.first.focus();
      }
    }
    /**
     * Focuses the view element or last item in view collection on opening dropdown's panel.
     *
     * See also {@link module:ui/dropdown/dropdownpanelfocusable~DropdownPanelFocusable}.
     */

  }, {
    key: "focusLast",
    value: function focusLast() {
      if (this.children.length) {
        var lastChild = this.children.last;

        if (typeof lastChild.focusLast === 'function') {
          lastChild.focusLast();
        } else {
          lastChild.focus();
        }
      }
    }
  }]);

  return DropdownPanelView;
}(View);

export { DropdownPanelView as default };